import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  makeStyles,
  TableBody,
  TableHead,
  Grid,
  TablePagination,
} from "@material-ui/core";
import {
  Toast,
  ConfirmationModal,
  SimpleToolbar,
  AddCategory,
  EditCategory,
  Category,
  Loader,
  Drawer,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "../components";
import { categoriesServices } from "../services";
import { AuthContext } from "../context";
import { useDrawer } from "../hooks";
import { handleDownloadExcel } from "../helpers";
const tableHeader = [
  "Categoría",
  "Descripción",
  "Doctor Asociado",
  "RUT",
  "Nombre",
  "Apellido",
  "Sexo",
  "Fecha de nacimiento",
  "Teléfono",
  "Teléfono de actividad",
  "Correo",
  "Especialidad 1",
  "Especialidad 2",
  "Especialidad 3",
];
export default function CategoriesScreen(props) {
  const classes = useStyles();
  const { authState, signOut } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [laboratoryId] = useState(
    authState.user ? authState.user.laboratory._id : null
  );
  const [openEdit, setOpenEdit] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [categoryToEdit, setCategoryToEdit] = useState(null);
  const [openAddCategoryModal, setOpenAddCategoryModal] = useState(false);
  const [categoryId, setCategoryId] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [reload, setReload] = useState(false);
  const { isOpen, setIsOpen } = useDrawer();
  const tableBody = useRef([]);

  useEffect(() => {
    const categoriesToReturn = [];
    categories.forEach((category) => {
      category.doctors.forEach((doctor) => {
        categoriesToReturn.push([
          category.name || "",
          category.description || "",
          "→",
          doctor.rut || "",
          doctor.name || "",
          doctor.lastName || "",
          doctor.gender || "",
          doctor.birthdate || "",
          doctor.phone || "N/A",
          doctor.activityPhone || "N/A",
          doctor.email || "N/A",
          doctor.specialties[0] ? doctor.specialties[0].name : "N/A",
          doctor.specialties[1] ? doctor.specialties[1].name : "N/A",
          doctor.specialties[2] ? doctor.specialties[2].name : "N/A",
        ]);
      });
    });
    const tableData = categoriesToReturn;
    tableBody.current = tableData;
  }, [categories]);

  useEffect(() => {
    setReload(false);
    async function getCategoriesLaboratory() {
      try {
        setLoading(true);
        const { status, response } =
          await categoriesServices.getCategoriesLaboratory({
            laboratoryId,
            token: authState.token,
            page,
            limit,
          });
        setLoading(false);
        if (status === 200) {
          setCategories(response.categories);
          setLimit(response.limit);
          setCount(response.total);
          setPage(response.page);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }
    getCategoriesLaboratory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState, page, limit, reload]);

  const getFilterCategoriesLaboratory = async (text) => {
    try {
      setLoading(true);
      const { status, response } =
        await categoriesServices.getFilterCategoriesLaboratory({
          text,
          token: authState.token,
          laboratoryId,
          page,
          limit,
        });
      setLoading(false);
      if (status === 200) {
        setCategories(response.categories);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const deleteCategory = async () => {
    try {
      setLoading(true);
      const { status, response } = await categoriesServices.deleteCategory({
        categoryId,
        token: authState.token,
      });
      setLoading(false);
      if (status === 200) {
        setReload(true);
        setToastMessage("Categoría eliminada");
        setToast(true);
      } else if (status === 401) {
        signOut();
      }
      if (response.error) {
        setToastMessage(response.error.message, true);
        setToast(true);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const getCategoryId = (_id) => {
    setOpenAlert(true);
    setCategoryId(_id);
  };

  const handleClose = (value) => {
    setOpenEdit(value);
  };

  const handleToast = (message, active) => {
    setToastMessage(message);
    setToast(active);
  };

  const getCategoryToEdit = (category) => {
    setOpenEdit(true);
    setCategoryToEdit(category);
  };

  const toolbarOptions = [
    {
      label: "Export excel",
      action: (e) => {
        handleDownloadExcel({
          filename: "Categorias",
          tableHeader: tableHeader,
          tableBody: tableBody.current,
        });
      },
    },
    {
      label: "Agregar",
      action: (e) => {
        setOpenAddCategoryModal(true);
      },
    },
  ];
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.container} style={{ flex: 1 }}>
        {loading && <Loader loading={true} />}
        <Grid item sm={12} xs={12}>
          <div className={classes.root}>
            <Toast
              message={toastMessage}
              open={toast}
              close={() => {
                setToast(false);
              }}
            />
            <ConfirmationModal
              open={openAlert}
              setOpenAlert={setOpenAlert}
              setConfirmAction={() => deleteCategory()}
            />
            {openEdit && (
              <EditCategory
                category={categoryToEdit}
                open={true}
                close={() => handleClose(false)}
                toast={(message, active) => handleToast(message, active)}
                reload={() => setReload(true)}
              />
            )}
            {openAddCategoryModal && (
              <AddCategory
                open={openAddCategoryModal}
                close={() => setOpenAddCategoryModal(false)}
                toast={(message, active) => handleToast(message, active)}
                reload={() => setReload(true)}
              />
            )}
            <Container maxWidth={false}>
              <SimpleToolbar
                // addButton
                // onAdd={() => setOpenAddCategoryModal(true)}
                onFilter={(text) => getFilterCategoriesLaboratory(text)}
                // table={"categoriesTable"}
                // filename={"Categorias"}
                isOpen={isOpen}
                setIsOpen={(value) => setIsOpen(value)}
                // tableHeader={tableHeader}
                // tableBody={tableBody}
                options={toolbarOptions}
              />
              <BaseTable tableId="categoriesTable">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell />
                    <StyledTableCell>Nombre</StyledTableCell>
                    <StyledTableCell>Descripción</StyledTableCell>
                    <StyledTableCell>Creación</StyledTableCell>
                    <StyledTableCell>Opciones</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {categories.map((category, index) => (
                    <Category
                      index={index}
                      key={category._id}
                      category={category}
                      getCategory={(category) => getCategoryToEdit(category)}
                      getCategoryId={(_id) => getCategoryId(_id)}
                    />
                  ))}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onChangeRowsPerPage={(e) => {
                  setLimit(parseInt(e.target.value));
                }}
                onChangePage={(e, page) => {
                  setPage(page + 1);
                }}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  pagination: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      bottom: 0,
    },
  },
}));
